export type WithTypename<T> = { __typename: T };

export enum StoreTypename {
  STORE_UI = 'Store.ui',
  USER = 'User'
}

export enum ViewStyle {
  TILE = 'TILE',
  LIST = 'LIST'
}

export enum UserSetting {
  LEFT_NAVIGATION = 'leftNavigation'
}
